import apiClient from './apiClient';
import { FT121 } from './t102Api';

export interface QueryResponse {
  data: FT121[];
  total: number;
  page: number;
  size: number;
  start_date: string;
  end_date: string;
}

export const t402Api = {
  async query(startDate: string, endDate: string, page = 1, size = 100): Promise<QueryResponse> {
    return (await apiClient.get('/api/t402/query', {
      params: { start_date: startDate, end_date: endDate, page, size },
    })).data;
  },
};
